import {
  CLEAR,
  LOGIN,
  REGISTER,
  LOGOUT,
  UPDATE_USER,
  UPDATE_USER_PROFILE_IMG,
  RECOVER,
} from "./types";
import firebase from "../../config/firebase";

export const register = (registerObj) => async (dispatch) => {
  dispatch({ type: REGISTER, payload: -1 });
  try {
    let userCredential = await firebase
      .auth()
      .createUserWithEmailAndPassword(registerObj.email, registerObj.password);
    let uid = await userCredential.user.uid;
    console.log(uid);
    delete registerObj["password"];
    registerObj["id"] = uid;
    await firebase.firestore().collection("users").doc(uid).set(registerObj);
    dispatch({
      type: REGISTER,
      payload: { message: "Account Created Successfuly", code: 201 },
    });
  } catch (error) {
    console.log(error.message);
    dispatch({
      type: REGISTER,
      payload: { message: error.message, code: 400 },
    });
  }
};
export const login = (loginObj) => async (dispatch) => {
  dispatch({ type: LOGIN, payload: -1 });
  try {
    let userCredential = await firebase
      .auth()
      .signInWithEmailAndPassword(loginObj.email, loginObj.password);
    let userId = userCredential.user.uid;
    var user = null;
    await firebase
      .firestore()
      .collection("users")
      .doc(userId)
      .onSnapshot((userDoc) => {
        user = { id: userDoc.id, ...userDoc.data() };
        dispatch({
          type: LOGIN,
          payload: {
            message: "You signed in successfully, please wait",
            code: 200,
            user,
          },
        });
      });
  } catch (error) {
    dispatch({
      type: LOGIN,
      payload: { message: error.message, code: 400 },
    });
  }
};
export const recoverAccount = (loginObj) => async (dispatch) => {
  dispatch({ type: RECOVER, payload: -1 });
  try {
    firebase
      .auth()
      .sendPasswordResetEmail(loginObj.email)
      .then((res) => {
        dispatch({
          type: RECOVER,
          payload: {
            message: "You will receive email for password reset",
            code: 200,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: RECOVER,
          payload: { message: err.message, code: 400 },
        });
      });
  } catch (error) {
    dispatch({
      type: RECOVER,
      payload: { message: error.message, code: 400 },
    });
  }
};
export const updateProfile = (profileObj) => async (dispatch) => {
  dispatch({ type: UPDATE_USER, payload: -1 });
  try {
    let user = firebase.auth().currentUser;
    await user
      .updateEmail(profileObj.email)
      .then(async () => {
        if (profileObj.password) await user.updatePassword(profileObj.password);
        let userObj = JSON.parse(localStorage.getItem("user_info"));
        if (userObj != null) {
          let id = userObj["id"];
          let nUser = await firebase
            .firestore()
            .collection("users")
            .doc(id)
            .get();
          nUser = nUser.data();
          nUser.email = profileObj.email;
          nUser.full_name = profileObj.full_name;
          await firebase.firestore().collection("users").doc(id).update(nUser);
          dispatch({
            type: UPDATE_USER,
            payload: {
              message: "User Updated Successfuly",
              code: 200,
              user: nUser,
            },
          });
        }
      })
      .catch((error) =>
        dispatch({
          type: UPDATE_USER,
          payload: { message: error.message, code: 400 },
        })
      );
  } catch (error) {
    dispatch({
      type: UPDATE_USER,
      payload: { message: error.message, code: 400 },
    });
  }
};
export const updateProfileImage = (image) => async (dispatch) => {
  dispatch({ type: UPDATE_USER_PROFILE_IMG, payload: -1 });
  try {
    let userObj = JSON.parse(localStorage.getItem("user_info"));
    if (userObj != null) {
      let id = userObj["id"];
      let user = await firebase.firestore().collection("users").doc(id).get();
      user = user.data();
      let unique_id = await firebase.firestore().collection("users").doc().id;
      let fileExt = image.name.split(".")[1];
      let fileName = unique_id + "." + fileExt;
      await firebase.storage().ref(`/profiles/${fileName}`).put(image);
      let url = await firebase
        .storage()
        .ref("profiles")
        .child(fileName)
        .getDownloadURL();
      user.profile_img = url;

      try {
        if (userObj["profile_img"] != null) {
          await firebase.storage().refFromURL(userObj["profile_img"]).delete();
          console.log("Deleted Old Image");
        }
      } catch (error) {
        console.log(error.message);
      }
      await firebase.firestore().collection("users").doc(id).update(user);
      dispatch({
        type: UPDATE_USER_PROFILE_IMG,
        payload: { message: "Profile Image Updated", code: 200, user },
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_USER_PROFILE_IMG,
      payload: { message: error.message, code: 400 },
    });
  }
};
export const logout = () => {
  return {
    type: LOGOUT,
  };
};
export const getUsers = () => async (dispatch) => {
  console.log("getUsers");
  firebase
    .firestore()
    .collection("users")
    .onSnapshot((snapshot) => {
      for (let doc of snapshot.docs) {
        console.log(doc.id, doc.data());
      }
    });
};

export const clear = (name) => {
  return { type: CLEAR, payload: name };
};
